import _default from './Step';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Step/index.js
// module id = 2715
// module chunks = 1